import bigCursorIcon from "../icons/bigCursorIcon.svg"
import stopAnimationsIcon from "../icons/stopAnimationsIcon.svg"
import readingGuideIcon from "../icons/readingGuideIcon.svg"
import pageReadIcon from "../icons/pageReadIcon.svg"
import muteSoundsIcon from "../icons/muteSoundsIcon.svg"

/**
 * Interface for tool preset configuration
 */
export interface ToolPreset {
    label: string;
    key: string;
    icon: string;
}

/**
 * Default tool presets for accessibility features
 */
const TOOL_PRESETS: readonly ToolPreset[] = [
    {
        label: 'Big Cursor',
        key: 'big-cursor',
        icon: bigCursorIcon,
    },
    {
        label: 'Pause Animations',
        key: 'stop-animations',
        icon: stopAnimationsIcon,
    },
    {
        label: 'Reading Guide',
        key: 'readable-guide',
        icon: readingGuideIcon,
    },
    {
        label: 'Page read',
        key: 'page-read',
        icon: pageReadIcon,
    },
    {
        label: 'Mute sounds',
        key: 'mute-sounds',
        icon: muteSoundsIcon,
    },
] as const;

export default TOOL_PRESETS;
